export enum GooglePlacesTypes {
  LOCALITY = 'locality',
  ROUTE = 'route',
  COUNTRY = 'country',
  ADMINISTRATIVE_AREA_LEVEL_1 = 'administrative_area_level_1',
  ADMINISTRATIVE_AREA_LEVEL_2 = 'administrative_area_level_2',
  ADMINISTRATIVE_AREA_LEVEL_3 = 'administrative_area_level_3',
  STREET_NUMBER = 'street_number',
  POSTAL_CODE = 'postal_code',
  SUBLOCALITY = 'sublocality',
  POSTAL_TOWN = 'postal_town',
  STREET_ADDRESS = 'street_address',
  PREMISE = 'premise',
  SUBPREMISE = 'subpremise',
}
